import React from "react";

const Feature = () => {
  return (
    <div className="feature">
      <div className="feature-content">
        <p>Contribute to offer smile and happiness</p>
      </div>
    </div>
  );
};

export default Feature;
